export default [
    {
        "q": "How does Vacancy help once I create my profile?",
        "a": "Once you create your profile, we will apply to employers on your behalf automatically using complex machine learning algorithms.Moreover our team comes with 15+ years of industry experience and knows what employers want in your profile and amend it accordingly."
    },
    {
        "q": "How does Vacancy find jobs that fit me?",
        "a": "We use Artificial intelligence and Machine learning algorithms to analyze your experiences and interests and find jobs that fit you best. But we do value your interests and opinions and suggest jobs based on those only."
    },
    {
        "q": "How can Vacancy improve my applications?",
        "a": "We've built a suite of tools that help you iterate your profile and resume to make you the best fit for the role as the employers want"
    },
    {
        "q": "Can I block some companies where I don't want to apply ?",
        "a": "Of course.Whether it's your current company or you are not simply interested in a particular company, we got you covered. Just add it in our block list and we won't apply or their recruiter will not be able to see your profile."
    },
    {
        "q": "How does Vacancy manage my data?",
        "a": "We use state-of-the-art AES-256 bit encryption (bank-level security) to keep your data secure. Your information is only sent to employers when requested & with your consent."
    }
]